import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { DcAlertService } from '@o3/ui-kit';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { ValidationService } from '../service/validation.service';
import { processDataForCsvDoc } from '../utils/helpers';

@Component({
  selector: 'app-rule-details',
  templateUrl: './rule-details.component.html',
  styleUrls: ['./rule-details.component.scss'],
})
export class RuleDetailsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() validationId;
  private subscriptions = new Subscription();
  loading;
  data;
  rows;
  columns;
  messages = {
    emptyMessage: 'No validations found.',
    totalMessage: 'Total',
  };
  sort = [
    {
      prop: 'createdDate',
      dir: 'desc',
    },
  ];
  pageTitle;
  ruleStatus;
  csvReadyData: any;
  csvSheetTitle: string;
  neededFieldsForCSV = [
    'id',
    'ruleId',
    'mnemonic',
    'description',
    'jmespath',
    'calculation',
    'pass',
  ];
  countFail;
  countPass;
  countTotal;
  filteredRows = [];
  selectedStatus = 'all';
  searchControl;
  searchText;
  constructor(
    private validationService: ValidationService,
    private dcAlertService: DcAlertService
  ) {}

  ngOnInit(): void {
    this.validationId = 'no validation selected';
    this.columns = [
      {
        name: 'e',
        prop: 'ruleId',
        resizeable: false,
        draggable: false,
        sortable: false,
        width: 26,
        maxWidth: 26,
        canAutoResize: false,
        headerTemplate: 'hdrTpl',
        cellTemplate: 'expandTemplate',
        flexGrow: 1,
        cellClass: 'expandCell',
        // headerClass: 'expandCell',
      },
      {
        name: 'Name',
        prop: 'name',
        resizeable: false,
        draggable: false,
        //minWidth: 160,
        canAutoResize: true,
        flexGrow: 2,
      },
      {
        name: 'Mnemonic',
        prop: 'mnemonic',
        resizeable: false,
        draggable: false,
        canAutoResize: true,
        flexGrow: 1,
      },
      {
        name: 'Description',
        prop: 'description',
        resizeable: false,
        draggable: false,
        minWidth: 80,
        canAutoResize: true,
        flexGrow: 2,
      },
      {
        name: 'Rule type',
        prop: 'ruleType',
        resizeable: false,
        draggable: false,
        minWidth: 80,
        canAutoResize: true,
        flexGrow: 2,
      },
      {
        name: 'status',
        prop: 'status',
        resizeable: false,
        draggable: false,
        canAutoResize: true,
        flexGrow: 2,
        cellTemplate: 'statusCircleTemplate',
        cellClass: 'text-right statusCell',
        headerClass: 'text-right status',
      },
    ];
    this.searchControl = new FormControl('');
    this.subscriptions.add(
      this.searchControl.valueChanges
        .pipe(distinctUntilChanged())
        .subscribe((change) => {
          this.searchText = change;
          //console.log(change);
          this.filterDataBySearchTerm({ text: this.searchText });
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getData();
  }

  getData() {
    this.pageTitle = 'Select a payload';

    if (this.validationId !== undefined) {
      this.loading = true;
      this.subscriptions.add(
        this.validationService.getRuleByKey(this.validationId).subscribe(
          (value) => {
            this.loading = false;
            this.selectedStatus = 'all';
            this.data = value;
            this.getSimpleRuleNumbers();
            if (value) {
              this.csvReadyData = processDataForCsvDoc(
                value
                // this.neededFieldsForCSV
              );
              this.csvSheetTitle =
                'Validation Summary for Payload ' +
                this.validationId?.ref +
                ' - ';
            }

            this.ruleStatus = this.validationId?.status.toLowerCase();
            this.rows = this.data?.validationResults;
            this.filteredRows = this.data?.validationResults;
            this.pageTitle = this.validationId?.ref + ' - ';
            this.searchControl.setValue('');
          },
          (error) => {
            this.dcAlertService.showAlert({
              type: 'warning',
              message: error.message,
            });
          }
        )
      );
    }
  }

  getSimpleRuleNumbers(): void {
    this.countFail = this.data.validationResults.filter(
      (item) => item.status === 'FAILED'
    ).length;
    this.countPass = this.data.validationResults.filter(
      (item) => item.status === 'PASSED'
    ).length;
    this.countTotal = this.data.validationResults.length;
  }

  statusClick(value): void {
    if (this.selectedStatus == value) return;
    this.selectedStatus = value;
    this.filterDataBySearchTerm({ status: value, text: this.searchText });

    // if (value == 'all') {
    //   this.selectedStatus = 'all';
    // }
  }

  filterDataBySearchTerm(filterValue: any): void {
    const status =
      this.selectedStatus !== 'all' ? this.selectedStatus : undefined;
    const text = filterValue.text ? filterValue.text : '';
    //console.log(status);
    //console.log(text);
    if (
      (status === undefined && text === undefined) ||
      (status === '' && text === '') ||
      (status == undefined &&
        (text === '' || text === null || text === undefined))
    ) {
      this.filteredRows = this.rows;

      return;
    }
    const columnProps = this.columns.map((column) => column.prop);
    // console.log('columnProps', columnProps);

    this.filteredRows = this.rows.filter((currentRow) => {
      //console.log('currentRow', currentRow);
      return columnProps
        .map((columnProp) => {
          if (currentRow[columnProp]) {
            //console.log(currentRow['description']);
            if (status !== undefined) {
              return (
                currentRow['status']
                  .toLowerCase()
                  .includes(status?.toLowerCase()) &&
                (currentRow['description']
                  .toLowerCase()
                  .includes(text?.toLowerCase()) ||
                  currentRow['name']
                    .toLowerCase()
                    .includes(text?.toLowerCase()) ||
                  currentRow['mnemonic']
                    .toLowerCase()
                    .includes(text?.toLowerCase()) ||
                  this.findText(currentRow, filterValue))
              );
            } else {
              //console.log(this.findText(currentRow, filterValue));
              //console.log('test', this.findText(currentRow, filterValue));
              return (
                currentRow['description']
                  .toLowerCase()
                  .includes(text?.toLowerCase()) ||
                currentRow['name']
                  .toLowerCase()
                  .includes(text?.toLowerCase()) ||
                currentRow['mnemonic']
                  .toLowerCase()
                  .includes(text?.toLowerCase()) ||
                this.findText(currentRow, filterValue)
              );
            }
          } else {
            return false;
          }
        })
        .reduce((previous, current) => previous || current);
    });
  }

  clearSearchInput(event): void {
    this.searchControl.setValue('');
  }

  findText(currentRow, filterValue): any {
    const text = filterValue.text ? filterValue.text : '';
    let count = 0;
    if (currentRow.hasOwnProperty('ruleResults')) {
      currentRow.ruleResults.forEach((element) => {
        element.ruleResults.forEach((element) => {
          if (
            element?.jmespath?.toLowerCase().includes(text.toLowerCase()) ||
            element?.payloadValue?.toLowerCase().includes(text.toLowerCase()) ||
            element?.calculation?.toLowerCase().includes(text.toLowerCase())
          ) {
            //console.log('found text in path', currentRow);
            count++;
          }
        });
      });
    }
    const hasText = count > 0 ? true : false;
    return hasText;
  }
}
